import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';



export default function SchoolDisOrderTypes(props) {
    const toast = useRef(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});
    

    useEffect(() => {
      setLoading(true);
      

      var params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0};
      var url = config.Server+`/school/setting/disorder-type-effect-score/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }, []);
    const checkDataEntry = function(){
      return true;
    }

    const saveItem = function(calcScores){
      if(!checkDataEntry()) return;
      var disorderTypes = [];
      for(var i=0;i<items.length;i++){
        disorderTypes.push({disorderTypeId:items[i].disorderType.id, effectScore:items[i].effectScore});
      }
      var params = {
        login:util.getTrustedUser(), 
        disorderTypes:disorderTypes
      };
      setSaving(true);
      var url = config.Server+`/school/setting/disorder-type-effect-score/save`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                                   
                  setSaving(false);
                  if(calcScores){
                    claculateEffectedScores();
                  }
                  else{
                    setErrorMessage("با موفقيت انجام گردید");
                    setErorVisible(true);
                  }
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const onInputChange = function(e, name, index){
      if(name === "effectScore"){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(val == "") val = 0;
        var rows = [...items];
        rows[index].effectScore = val;
        setItems(rows);
      }
    }
    const claculateEffectedScores = function (){
      if(!checkDataEntry()) return;
      var params = {
        login:util.getTrustedUser(), 
      };
      setSaving(true);
      var url = config.Server+`/school/disorder/calculate/all`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){                                   
                  setSaving(false);
                  setErrorMessage("با موفقيت انجام گردید");
                  setErorVisible(true);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
      
    }
    return(      
      <>
         
          <div className="card" style={{width:"100%", maxWidth:"525px", borderBlockColor:"#414141",marginTop:"20px" }}>
            
          <table style={{width:"100%", borderCollapse:"collapse"}}>
            <tbody>
              <tr><td colSpan={4} style={{backgroundColor:"royalblue", color:"#FFFFFF",padding:"5px", borderRadius:"5px", fontSize:"14pt", textAlign:"center"}}>ثبت انواع رفتار</td></tr>
              <tr><td colSpan={4}>&nbsp;</td></tr>
              <tr>
                <td style={{width:"50px", textAlign:"center"}}>کد</td>
                <td style={{width:"250px", textAlign:"center"}}>نوع رفتار</td>
                <td style={{width:"80px", textAlign:"center"}}>نمره مثبت</td>
                <td style={{width:"80px", textAlign:"center"}}>نمره منفی</td>
                <td style={{width:"2px", textAlign:"center"}}>&nbsp;</td>
              </tr>
              {
                items.map((row, index)=>{
                  return (
                    <tr>
                      <td style={{border:"1px solid #b0b0b0", padding:"5px", textAlign:"center"}}>{row.disorderType.code}</td>
                      <td style={{border:"1px solid #b0b0b0", padding:"5px", textAlign:"center"}}>{row.disorderType.title}</td>
                      <td style={{border:"1px solid #b0b0b0"}}>
                        {
                          row.disorderType.zarib==1?
                          <InputText keyfilter={"num"} mode={"decimal"} inputId={"effectScore_"+index} value={row.effectScore} onChange={(e) => onInputChange(e, "effectScore", index)} useGrouping={false}  maxLength={5} style={{textAlign:"center", width:"100%"}}/>
                          :
                          <></>
                        }
                        
                      </td>
                      <td style={{border:"1px solid #b0b0b0"}}>
                        {
                          row.disorderType.zarib==-1?
                          <InputText keyfilter={"num"} mode={"decimal"} inputId={"effectScore_"+index} value={row.effectScore} onChange={(e) => onInputChange(e, "effectScore", index)} useGrouping={false}  maxLength={5} style={{textAlign:"center", width:"100%"}}/>
                          :
                          <></>
                        }
                        
                      </td>
                      <td></td>
                    </tr>
                  )
                }
                )
              }
              <tr><td colSpan={4}>&nbsp;</td></tr>
              <tr>
                <td colSpan={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label="ثبت شوند" icon="pi pi-check" onClick={()=>saveItem(false)} severity="success" iconPos="right" loading={saving} />
                    
                  </div>
                </td>
                <td>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label="محاسبه مجدد نمره دانش آموزان" icon="pi pi-check" onClick={()=>saveItem(true)} severity="primary" iconPos="right" loading={saving} />
                    
                  </div>
                </td>
                <td>
                </td>
              </tr>
              <tr><td colSpan={4}>&nbsp;</td></tr>

            </tbody>
          </table>            
          </div>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
